import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/views/Index'
import AppointDetail from '@/views/AppointDetail'
import NotFoundComponent from '@/views/NotFoundComponent'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '*',
      component: NotFoundComponent
    },

    {
      path: '/home',
      name: 'home',
      component: Index,
      meta: {
        keepAlive: true // 需要被缓存
      }
    },
    {
      path: '/detail',
      name: 'detail',
      component: AppointDetail,
      meta: {
        keepAlive: false // 不需要缓存
      }
      // props: (route) => ({ query: route.query.q })
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js